// extracted by mini-css-extract-plugin
export default {"problem_box":"problem_box_liAMV","box":"box_LJVwy","content":"content_eYQC9"};